module.exports = __webpack_public_path__ + "img/close.02295145.svg";